<template>
  <el-dialog v-if="visible" :visible.sync="visible" :title="dialogTitle" :width="dialogWidth">
    <slot ref="slot" v-bind="$attrs" v-on="$listeners"></slot>
    <div slot="footer" class="dialog-footer">
      <el-button @click="ok()">{{this.dialogOk}}</el-button>
      <el-button type="primary" @click="cancel()">{{this.dialogCancel}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    dialogTitle: {
      type: String,
      default() {
        return this.$t('common.create');
      },
    },
    dialogOk: {
      type: String,
      default() {
        return this.$t('common.confirm');
      },
    },
    dialogCancel: {
      type: String,
      default() {
        return this.$t('common.cancel');
      },
    },
    dialogWidth: {
      type: String,
      default: '600px',
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    show() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    ok() {
      this.$refs.slot.$emit('ok');
    },
    cancel() {
      this.$refs.slot.$emit('cancel');
    },
  },

};
</script>

<style>

</style>
